module.exports = __webpack_public_path__ + "img/comp-rockpi.1913ac9c.svg";